import {toAbsoluteUrl} from '../../../helpers'

export function FallbackView() {
  return (
    <div className='splash-screen'>
      <img src={toAbsoluteUrl('/media/logos/logo-idefix.svg')} alt='İdefix logo' />
      <span>Loading ...</span>
    </div>
  )
}
